window.addEventListener( 'alpine:init', bootstrap );

export default () => ({
	expanded: false,
	$header: null,
	init() {
		this.$header = document.getElementById('site-header');
	},
	expand() {
		this.expanded = true;
		this.$header.classList.add('search-expanded');
	},
	collapse() {
		this.expanded = false;
		this.$header.classList.remove('search-expanded');
	}
});

function bootstrap() {
	document.querySelectorAll('.js-alpine-site-search')
		.forEach( $el => bootstrapSearch($el) )
	;
}

function bootstrapSearch($el) {
	$el.setAttribute('x-data', 'siteSearch');
	$el.setAttribute('x-on:click.self', 'expand');
	$el.setAttribute('x-on:click.outside', 'collapse');
	/* eslint-disable */
	$el.setAttribute(':class', "{ 'is-expanded': expanded }");
	const $input = $el.querySelector('input[type="search"]');
	/* eslint-enable */
	if ( $input ) {
		$input.removeAttribute('placeholder');
	}
}
